import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

type MutationError = FetchBaseQueryError | SerializedError | undefined;

export const handleMutationError = (error: MutationError): string => {
    if (!error) {
      return 'Ocurrió un error desconocido.';
    }
  
    // Controlar error como FetchBaseQueryError con data detallada
    if ('status' in error) {
      const baseError = error as FetchBaseQueryError;
      
      // Verificar si hay un mensaje error en data
      if (typeof baseError.data === 'object' && baseError.data !== null && 'error' in baseError.data) {
        return (baseError.data as { error?: string }).error || 'Error en la respuesta del servidor.';
      }
  
      return `Error de red: ${baseError.status}`;
    }
  
    // Controlar error serializado
    if ('message' in error) {
      return error.message || 'Ocurrió un error serializado.';
    }
  
    return 'Error inesperado.';
  };